<script>
import stronglyAgree from '@/images/stronglyAgree.png';
import agree from '@/images/agree.png';
import neutral from '@/images/noAgreeOrDisagree.png';
import disagree from '@/images/disagree.png';
import stronglyDisagree from '@/images/stronglyDisagree.png';
import axios from 'axios';
import config from '@/utils/config';

export default {
  props: {
    user: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      questions: [
        { id: 1, text: "1. Se avessi quest’app a disposizione, penso che la userei molto spesso", answer: null },
        { id: 2, text: "2. Mi sono sentito/a confuso/a tante volte mentre usavo l’app", answer: null },
        { id: 3, text: "3. Ho trovato l’app facile da usare", answer: null },
        { id: 4, text: "4. Avrei bisogno di aiuto per continuare a usare l’app", answer: null },
        { id: 5, text: "5. Mentre usavo l’app, sapevo sempre cosa fare dopo", answer: null },
        { id: 6, text: "6. Alcune cose che dovevo fare con l’app non avevano molto senso", answer: null },
        { id: 7, text: "7. Penso che i miei amici potrebbero imparare a usare l’app molto velocemente", answer: null },
        { id: 8, text: "8. Alcune cose che dovevo fare con l’app erano un po' strane", answer: null },
        { id: 9, text: "9. Mi sentivo sicuro/a mentre usavo l’app", answer: null },
        { id: 10, text: "10. Ho dovuto imparare tante cose prima di usare bene l’app", answer: null },
      ],
      responseOptions: [
        { emoji: stronglyDisagree, value: 1, label: "Fortemente in disaccordo" },
        { emoji: disagree, value: 2, label: "In disaccordo" },
        { emoji: neutral, value: 3, label: "Neutro" },
        { emoji: agree, value: 4, label: "D'accordo" },
        { emoji: stronglyAgree, value: 5, label: "Fortemente d'accordo" },
      ],
      currentPage: 1,
      questionsPerPage: 5
    };
  },
  computed: {
    totalPages() {
      return Math.ceil(this.questions.length / this.questionsPerPage);
    },
    currentQuestions() {
      const start = (this.currentPage - 1) * this.questionsPerPage;
      return this.questions.slice(start, start + this.questionsPerPage);
    },
    allAnswered() {
      return this.currentQuestions.every(question => question.answer !== null);
    }
  },
  methods: {
    setAnswer(question, option) {
      question.answer = option.value;
    },
    nextPage() {
      if (this.currentPage < this.totalPages) {
        this.currentPage++;
      }
    },
    previousPage() {
      if (this.currentPage > 1) {
        this.currentPage--;
      }
    },
    submitAnswers() {
      const payload = {
        frequenzaUso: this.questions[0].answer,
        confusioneDuranteUso: this.questions[1].answer,
        facilitaUso: this.questions[2].answer,
        bisognoAiuto: this.questions[3].answer,
        chiarezzaAzioni: this.questions[4].answer,
        sensoDelleAzioni: this.questions[5].answer,
        facilitaApprendimentoAmici: this.questions[6].answer,
        stranezzaAzioni: this.questions[7].answer,
        sicurezzaDuranteUso: this.questions[8].answer,
        apprendimentoPreliminare: this.questions[9].answer,
        user: { id: this.user.id }
      };
      axios.post(config.baseUrl + `/finalQuestionnaire/addScores`, payload)
        .then(() => {
          this.$emit('questionnaire-completed');
        })
        .catch(error => {
          console.error('Error posting questionnaire:', error);
        });
    }
  },
};
</script>

<template>
  <div class="survey-wrapper">
    <h3>Questionario di fine sperimentazione</h3>
    <p class="description">Giunto a questo punto della sperimentazione vogliamo sapere la tua opinione.</p>
    <p class="description">Questo sarà l'ultimo questionario che ti proporremo.</p>
    
    <div class="survey-container">
      <div v-for="question in currentQuestions" :key="question.id" class="question-item">
        <p class="question-text">{{ question.text }}</p>
        <div class="options">
          <button
            v-for="option in responseOptions"
            :key="option.value"
            @click="setAnswer(question, option)"
            :class="{ selected: question.answer === option.value }">
            <img :src="option.emoji" alt="emoji" class="emoji-img" />
            <span class="option-label">{{ option.label }}</span>
          </button>
        </div>
      </div>
      <div class="navigation">
        <button @click="previousPage" :disabled="currentPage === 1">Indietro</button>
        <button v-if="currentPage < totalPages" @click="nextPage" :disabled="!allAnswered">Avanti</button>
        <button v-else @click="submitAnswers" :disabled="!allAnswered">Invia Risposte</button>
      </div>
    </div>
  </div>
</template>

<style scoped>
* {
    caret-color: transparent;
    box-sizing: border-box;
} 

.survey-wrapper {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
    text-align: center;
    font-family: 'Arial', sans-serif;
}

h3 {
    font-size: 26px;
    color: white;
    font-weight: bold;
    margin-bottom: 10px;
}

.description {
    font-size: 16px;
    color: white;
    margin-bottom: 20px;
    line-height: 1.6;
}

.survey-container {
    background: #fff;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
}

.question-item {
    padding: 15px;
    border-bottom: 1px solid #ddd;
}

.question-text {
    font-size: 16px;
    font-weight: 500;
    color: #333;
    margin-bottom: 10px;
}

.options {
    display: flex;
    justify-content: center;
    gap: 10px;
    flex-wrap: wrap;
}

.options button {
    background-color: #f9f9f9;
    border: 2px solid #ddd;
    border-radius: 8px;
    padding: 10px;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    align-items: center;
    transition: all 0.3s ease;
    font-size: 14px;
    width: 120px;
    text-align: center;
}

.emoji-img {
    width: 40px;
    height: 40px;
}

.options button:hover {
    background-color: #e0e0e0;
    transform: scale(1.05);
}

.options button.selected {
    background-color: #cce5ff;
    border-color: #007bff;
}

.submit-btn {
    margin-top: 20px;
    padding: 12px 30px;
    font-size: 18px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 25px;
    cursor: pointer;
    transition: all 0.3s ease;
}

.submit-btn:hover {
    background-color: #0056b3;
}

.submit-btn:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}

.navigation {
    display: flex;
    justify-content: space-between;
    margin-top: 20px;
}

.navigation button {
    padding: 10px 20px;
    font-size: 16px;
    background-color: #007bff;
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.3s ease;
}

.navigation button:hover {
    background-color: #0056b3;
}

.navigation button:disabled {
    background-color: #ccc;
    color: #666;
    cursor: not-allowed;
    transition: none;
}

</style>